import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-10 sm:py-16">
      <h1 className="text-3xl font-bold text-center" style={{ fontFamily: "Outfit" }}>Recuperar senha</h1>
      {sent ? (
        <div className="mt-8 space-y-4 bg-white border rounded-xl p-6 text-center" data-testid="forgot-success">
          <CheckCircle2 className="h-14 w-14 mx-auto text-green-600" />
          <p className="text-neutral-700">Se o e-mail estiver cadastrado, enviaremos instruções para redefinir sua senha em instantes.</p>
          <p className="text-xs text-neutral-500">Ambiente atual: envio de e-mail ainda não configurado — a loja gera o link mas depende de um provedor (ex.: Resend) para entregar.</p>
          <Link to="/entrar"><Button variant="outline">Voltar para entrar</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4 bg-white border rounded-xl p-6">
          <p className="text-sm text-neutral-600">Informe o e-mail cadastrado. Enviaremos um link seguro para você redefinir sua senha.</p>
          <div>
            <Label>E-mail</Label>
            <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full bg-[#C91F1F] hover:bg-[#9F1515] h-11">
            {loading ? "Enviando..." : "Enviar link de recuperação"}
          </Button>
          <p className="text-sm text-center text-neutral-600">
            <Link to="/entrar" className="text-[#C91F1F] font-semibold">Voltar</Link>
          </p>
        </form>
      )}
    </div>
  );
}
